import React from 'react';
import './StudentDashboard.css'; // Import the CSS styles

const StudentDashboard = ({ student }) => {
  return (
    <div className="dashboard-container">
      <h1 className="dashboard-title">Student Dashboard</h1>
      <div className="student-card">
        <img
          src={student?.profileImage || "https://via.placeholder.com/100"}
          alt="Profile"
          className="profile-img"
        />
        <div className="student-info">
          <p><strong>Name:</strong> {student.name}</p>
          <p><strong>Roll No:</strong> {student.roll}</p>
          <p><strong>Email:</strong> {student.email}</p>
          <p><strong>Department:</strong> {student.department}</p>
        </div>
      </div>

      <div className="stats-section">
        <div className="stat-box">
          <p>Attendance</p>
          <h3>{student.attendance}%</h3>
        </div>
        <div className="stat-box">
          <p>CGPA</p>
          <h3>{student.cgpa}</h3>
        </div>
        <div className="stat-box">
          <p>Projects</p>
          <h3>{student.projects}</h3>
        </div>
      </div>
    </div>
  );
};

export default StudentDashboard;
